export default __webpack_public_path__ + "static/rp-1a04e0e7d113613e97067b4b38e4cc4c.png";